export default __webpack_public_path__ + "static/media/0x0b68782eff3177f1f9240b64a7e2f8e0497e2454.cb6acd92.webp";